import React from 'react';
import PropTypes from 'prop-types';
import { Label } from './checkbox-radio.style';

const CheckboxRadioComponent = ({ type = 'checkbox', label, ...props }) => {
    return (
        <Label>
            <input type={type} {...props} />
            {
                label &&
                <span>{label}</span>
            }
        </Label>
    );
};

CheckboxRadioComponent.propTypes = {
    type: PropTypes.oneOf(['checkbox', 'radio']),
    label: PropTypes.string,
};

export default CheckboxRadioComponent;
